import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
/* import RelatedWorks from "./RelatedWorks"; */
import "./Mgrdetail.css";

export default function MgrDetail() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          MGR University Prospectus
        </h1>

        <p className="project-description">
          We designed and produced a comprehensive admissions prospectus that communicates the university's academic offerings, campus life, and institutional identity through engaging editorial design and high-quality print production.       </p>

        <div className="project-tags">
          <span className="info-tag">Prospectus Design</span>
          <span className="info-tag">Editorial Design</span>
        </div>

        
      </section>
      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/MGR/Mgr1.webp" 
          alt="MGR Book Mockup" 
        />
      </div>
      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/MGR/Mgr2.webp" 
          alt="MGR Book Mockup" 
        />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Designed to inform, engage, and inspire prospective students, the prospectus reflects the university's academic excellence through clear communication, structured layouts, and impactful visual storytelling."
        </div>
      </section>

      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/MGR/Mgr4.webp" 
          alt="MGR Book Mockup" 
        />
      </div>
      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/MGR/Mgr3.webp" 
          alt="MGR Book Mockup" 
        />
      </div>
      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Designed to inform, engage, and inspire prospective students, the prospectus reflects the university's academic excellence through clear communication, structured layouts, and impactful visual storytelling."
        </div>
      </section>

  

      {/* <RelatedWorks excludePath="/works/mgr" /> */}
      <Footer />
    </div>
  );
}
